import { forwardRef, useCallback } from "react"
import { map, size } from "lodash"
import PropTypes from "prop-types"
import { Grid2 as Grid, Typography } from "@mui/material"
import { ROLE, CURRENCY } from "helpers/shapes"
import Swap from "../swap"
import Watchlist from "../watchlist"
import Portfolio from "../portfolio"
import Topic from "../topic"

import "./styles.scss"

const RecentResources = forwardRef(({ resources, ...props }, ref) => {
  const renderResourceCard = useCallback((resource) => {
    let ResourceCard, resourceHandlers
    const {
      dispatch, account, openDialog, openSecurityProfile, deleteSwap, editSwap, updateWatchlist, deleteWatchlist,
      deleteTopic, updateTopic, updatePortfolio, deletePortfolio, models, trackResourceEvent, toggleFavorite, model, isOpPro, role,
      intradayAccountEnabled, supportedCurrencies, accountDefaultCurrencyId,
    } = props

    switch (resource.resourceType) {
      case "swap":
        ResourceCard = Swap
        resourceHandlers = { deleteSwap, editSwap, openSecurityProfile }
        break
      case "watchlist":
        ResourceCard = Watchlist
        resourceHandlers = { deleteWatchlist, updateWatchlist }
        break
      case "topic":
        ResourceCard = Topic
        resourceHandlers = { deleteTopic, updateTopic }
        break
      default:
        ResourceCard = Portfolio
        resourceHandlers = { deletePortfolio, updatePortfolio }
        break
    }

    return <ResourceCard
      key={resource.id || resource.ticker}
      dispatch={dispatch}
      account={account}
      toggleFavorite={toggleFavorite}
      trackResourceEvent={trackResourceEvent}
      models={models}
      model={model}
      isOpPro={isOpPro}
      openDialog={openDialog}
      resource={resource}
      role={role}
      handlers={resourceHandlers}
      permissionLevel={resource.permissionLevel}
      linkedToAlphaTheory={resource.isLinkedToAlphaTheory}
      intradayAccountEnabled={intradayAccountEnabled}
      supportedCurrencies={supportedCurrencies}
      accountDefaultCurrencyId={accountDefaultCurrencyId}
    />
  }, [props])

  if (size(resources) === 0) { return null }

  return <div ref={ref} className="component_recent-resources">
    <Typography className="title" variant="h6" component="h2">Recently opened</Typography>
    <Grid container className="resources-container">
      {map(resources, resource => <Grid key={resource.id} className="resource-container">{renderResourceCard(resource)}</Grid>)}
    </Grid>
  </div>
})

RecentResources.displayName = "RecentResources"

RecentResources.propTypes = {
  resources: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  openDialog: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  deleteSwap: PropTypes.func.isRequired,
  editSwap: PropTypes.func.isRequired,
  updateWatchlist: PropTypes.func.isRequired,
  deleteWatchlist: PropTypes.func.isRequired,
  deleteTopic: PropTypes.func.isRequired,
  updateTopic: PropTypes.func.isRequired,
  updatePortfolio: PropTypes.func.isRequired,
  deletePortfolio: PropTypes.func.isRequired,
  models: PropTypes.object.isRequired,
  trackResourceEvent: PropTypes.func.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  model: PropTypes.string,
  isOpPro: PropTypes.bool.isRequired,
  role: ROLE.isRequired,
  intradayAccountEnabled: PropTypes.bool,
  supportedCurrencies: PropTypes.arrayOf(CURRENCY),
  accountDefaultCurrencyId: PropTypes.string,
}

export default RecentResources
